import styled from "@emotion/styled";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import type { ReactNode } from "react";

import { useFormatMessage } from "@skilitics/localization";

import { Button } from "../buttons";
import { SkiliticsIcon } from "../icons";
import { zIndexes } from "../utilities";
interface ErrorButtonProps {
  label: ReactNode;
  onClick: () => void;
  color?: "error" | "primary" | "secondary";
}

interface Props {
  text: ReactNode;
  title: ReactNode;
  buttonsProps?: ErrorButtonProps[];
}

export const ErrorDialog = ({ text, title, buttonsProps }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);
  return (
    <Dialog open sx={{ zIndex: zIndexes.errorDialog }}>
      <Header>
        <SkiliticsIcon icon="error" size={18} />
        {title}
      </Header>
      <Content>{text}</Content>
      <Footer>
        <Button variant="contained" color="error" onClick={() => window.location.reload()}>
          {formatMessage("reload")}
        </Button>
        {buttonsProps?.map(({ label, onClick, color = "error" }, index) => (
          <Button key={index} onClick={onClick} variant="outlined" color={color}>
            {label}
          </Button>
        ))}
      </Footer>
    </Dialog>
  );
};

const Header = styled(DialogTitle)`
  background: ${({ theme }) => theme.errorContainer};
  color: ${({ theme }) => theme.onErrorContainer};
  gap: 10px;
  display: flex;
  align-items: center;
`;

const Content = styled(DialogContent)`
  && {
    padding-top: 20px;
  }
  max-width: 600px;
  max-height: 400px;
  font-size: ${({ theme }) => theme.fontSizeLarge};
  line-height: 1.5;
  padding-bottom: 10px;
  > div {
    margin-bottom: 10px;
  }
`;

const Footer = styled(DialogActions)`
  flex-direction: row-reverse;
  justify-content: space-between;
  padding: 10px 20px 20px;
  button {
    margin-left: 0 !important;
  }
`;

const formatStrings = {
  reload: {
    en: "Reload Page",
  },
};
